// Formato real de filtro do Banco de Questões (mesmo usado pelo tema default —
// src/pages/Admin/Questions/QuestionsFilters.jsx e src/services/questions.js).
export const INITIAL_FILTERS = {
  ineditas: undefined,
  etapa: [],
  usadas_em: [],
  'taxonomies.id': [],
  descritor_ids: []
};

// Atalhos v1 — mesmos valores de filtro do Banco de Questões default
// (src/pages/Admin/Questions/presets.js), pra bater com a API real.
export const PRESETS = [
  {
    id: 'ineditas-bncc',
    label: 'Inéditas BNCC',
    description: 'Questões nunca usadas em caderno, das etapas BNCC (2º/5º/9º EF)',
    filters: { ineditas: 'true', etapa: ['ano_2_ef', 'ano_5_ef', 'ano_9_ef'] }
  },
  {
    id: 'sem-uso',
    label: 'Sem uso',
    description: 'Questões que nunca entraram num caderno',
    filters: { ineditas: 'true' }
  },
  {
    id: 'reaproveitaveis-de-provas',
    label: 'Reaproveitáveis de provas',
    description: 'Questões reaproveitáveis de cadernos tipo prova',
    filters: { usadas_em: ['exam'] }
  }
];
